<template>
    <form-component
        :timestamp="timestamp"
        :section="section"
        :type="type"
        :bindKeys="true"

        :id="id"
        :parent="parent"
        :attributes="attributes"
        :meta="meta"
        :schema="schema"
        :config="formConfig"
        :resourceParams="resourceParams"

        :changeUrl="changeUrl"
        :changeSection="changeSection"
        :changeQuery="changeQuery"

        :haltFetch="haltFetch"
        :addNotification="addNotification"
        :commitQueue="commitQueue"
        :pushQueue="pushQueue"

        :createData="createData"
        :updateData="updateData"
        :deleteData="deleteData"

        :onInitialized="onInitialized"
        :onCreated="onCreated"
        :onChanged="onChanged"
        :onUpdated="onUpdated"
        :onDeleted="onDeleted"
        ></form-component>
</template>

<script>
import V from 'voca';
import _ from 'lodash';

import FormComponent from './FormComponent';

export default {
    data() {
        return {};
    },

    props: [
        'id', 'resourceParams', 'type', 'parent',
        'attributes', 'meta', 'schema', 'timestamp', 'section',
        'createData', 'updateData', 'deleteData',
        'changeQuery', 'changeUrl', 'changeSection', 'haltFetch',
        'onCreated', 'onUpdated', 'onDeleted', 'onChanged', 'onInitialized',
        'addNotification', 'bindKeys', 'commitQueue', 'pushQueue',
    ],

    components: {
        FormComponent,
    },

    watch: {

    },

    computed: {
        formConfig() {
            const key = this.type;
            return this.config(['form', key]);
        }
    },

    mounted() {

    },

    destroyed() {

    },

    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/ItemComponent.vue